import ImportedProjectLobbyView from 'ImportedProjectLobby/views/ImportedProjectLobbyView';

export default ImportedProjectLobbyView;
